import { PageAlertsEffects } from '@rci/self-serve-fido/shared/page-alert/state/page-alerts.effects.service';
import { AccountDetailEffects } from '@rci/self-serve-fido/state/account/account-detail.effects';
import { AlertEffects } from '@rci/self-serve-fido/state/alert/alert.effects';
import { AppStateEffects } from '@rci/self-serve-fido/state/auth/auth.effects';
import { TargetedOffersEffects } from '@rogers/self-serve-targeted-offers';
import { PortInAlertsEffects } from '../port-in/port-in-alerts-effects';
import { UserInformationEffects } from './user-information';

export const globalEffectsList = [
  AccountDetailEffects,
  AlertEffects,
  AppStateEffects,
  TargetedOffersEffects,
  UserInformationEffects,
  PageAlertsEffects,
  PortInAlertsEffects,
];
